"use strict";

define('uikit/extra/rendering.manager',['underscore', './animation.frame.polyfill'], function (_) {
  var renderer = {
    queue: [],
    debugging: false,
    ids: [],
    _requested: false,
    requestRender: function requestRender(fn, id) {
      if (this.verbose) {
        console.log('view with id', id, 'requesting render');
      }
      if (this.debugging) {
        return fn();
      }
      var index = _.indexOf(renderer.ids, id);
      if (index > -1) {
        renderer.queue.splice(index, 1);
        renderer.ids.splice(index, 1);
      }
      renderer.queue.push(fn);
      renderer.ids.push(id);
      if (!renderer._requested) {
        renderer._requested = true;
        window.requestAnimationFrame(renderer.drain);
      }
    },
    drain: function drain() {
      while (renderer.queue.length) {
        var id = renderer.ids.shift();
        if (this.verbose) {
          console.log('view with id', id, 'before render');
        }
        renderer.queue.shift()();
        if (this.verbose) {
          console.log('view with id', id, 'after render');
        }
      }
      renderer._requested = false;
    }
  };
  window.__renderingManager = renderer;
  return renderer;
});

